export const administratorFields = ['user', 'username', 'roleIds', 'status'];
